import jwt from 'jsonwebtoken';
import type { Locale } from '@libs/core';

import { ENV_VARIABLES } from '../constants';
import type { CustomSignOptions } from '../types';

export const generateToken = (locale: Locale) => {
    const { DOORDASH_SIGNING_SECRET, DOORDASH_KEY_ID, DOORDASH_DEVELOPER_ID } =
        ENV_VARIABLES[locale];

    const data: CustomSignOptions = {
        iat: Math.floor(Date.now() / 1000),
        exp: Math.floor(Date.now() / 1000) + 60,
        iss: DOORDASH_DEVELOPER_ID as string,
        kid: DOORDASH_KEY_ID as string,
        aud: 'doordash',
    };
    const headers = {
        alg: 'HS256',
        'dd-ver': 'DD-JWT-V1',
    };
    return jwt.sign(
        data,
        Buffer.from(DOORDASH_SIGNING_SECRET || '', 'base64'),
        {
            algorithm: 'HS256',
            header: headers,
        }
    );
};
